import React, { Component } from 'react';
import {
    Container,
    Card,
    CardHeader, CardBody,
    Row,
    Col,
    Input,
    Collapse
} from 'reactstrap';
import './LinkedCompanies.css';
import Autocomplete from '../../components/Autocomplete/Autocomplete.js';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import CollapseCard from '../../components/CollapseCard/CollapseCard.js'
import ConfirmButton from '../Modal/ConfirmButton.js';
import CompanyContext from '../../auth/CompanyContext.js';

class LinkedCompanies extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);
        this.state = {
            linkedCompanies: [],
            open: (this.props.open !== undefined) ? this.props.open : false,
        };

    }

    componentDidMount() {
        this.getLinkedCompanies();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    uuidv4 = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }

    getLinkedCompanies = () => {
        fetch('/api/linkedCompanies/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    return {
                        linkedCompanies: results.data
                    };
                });
            });
    }

    onSelectAutocomplete = (val, id) => {
        const json_request = JSON.stringify({
            parentID: id,
            name: val.name,
            sec: val.sec,
            earliest: val.earliest,
            latest: (val.latest === this.props.available_dates[this.props.available_dates.length - 1].date_key) ? '' : val.latest,
            organization: val.organization,
            auth0: this.props.user
        });
        fetch('/api/linkedCompanies/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(() => this.getLinkedCompanies());
    }

    onRemove = (id) => {
        fetch('/api/linkedCompanies/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(() => this.getLinkedCompanies());
    }

    handleDateInputChange = (e, masterIndex, childIndex) => {
        let linkedCompanies = [...this.state.linkedCompanies];
        if (childIndex >= 0) {
            linkedCompanies[masterIndex].children[childIndex][e.target.name] = e.target.value;
        } else {
            linkedCompanies[masterIndex][e.target.name] = e.target.value;
        }
        this.setState(
            {
                linkedCompanies: linkedCompanies
            }, () => fetch('/api/linkedCompanies/', {
                method: 'PUT',
                body: JSON.stringify({
                    id: childIndex >= 0 ? linkedCompanies[masterIndex].children[childIndex].ID : linkedCompanies[masterIndex].ID,
                    earliest: childIndex >= 0 ? linkedCompanies[masterIndex].children[childIndex].Earliest : linkedCompanies[masterIndex].Earliest,
                    latest: childIndex >= 0 ? linkedCompanies[masterIndex].children[childIndex].Latest : linkedCompanies[masterIndex].Latest,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
        );
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        const timeout = 1000;
        const showHistory = true;
        return (
            <Container fluid>
                <Card>
                    <CardHeader onClick={() => this.showHide()}>
                        <Row className="align-items-center">
                            <Col className="col-xs-7 text-left">
                                <h3>Linked Companies</h3>
                            </Col>
                            <Col className="col-xs-4 text-right" onClick={(e) => e.stopPropagation()} >
                                <Autocomplete {...this.props}
                                    clientToken={this.props.clientToken}
                                    available_dates={this.props.available_dates}
                                    newPage={false}
                                    timeout={timeout}
                                    showHistory={showHistory}
                                    placeholder="Search to Add Master Company"
                                    onSelect={(val) => this.onSelectAutocomplete(val, null)}
                                    clearOnSelect={true}
                                    showContacts={false}
                                />
                            </Col>
                            <Col xs="1" className="text-right">
                                {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.open}>
                        <CardBody>
                            {this.state.linkedCompanies.map((master, masterIndex) => (
                                <Row key={"companies" + master.ID} className="linkedCompanies">
                                    <Col className="col-md-12">
                                        <CollapseCard title={master.Name} open={false} header="h4">
                                            <Row className="linkedMaster py-2 align-items-center">
                                                <Col md={5} className="text-left linkedChildName">
                                                    <Link to={{ pathname: '/demographics/' + master['SEC#'], state: { currentDate: master.Latest === '' ? [...this.props.available_dates].pop().date_key : String(master.Latest).substr(-6) } }}>{master.Name}</Link>
                                                </Col>
                                                <Col md={3} className="py-2">
                                                    <Input
                                                        type="select"
                                                        name="Earliest"
                                                        onChange={e => this.handleDateInputChange(e, masterIndex)}
                                                        value={master.Earliest}
                                                    >
                                                        {[...this.props.available_dates].reverse().map(d => (
                                                            <option key={'earliest_current_date_' + d.date_key} value={d.date_key}>{d.date_string}</option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                                <Col md={3} className="py-2">
                                                    <Input
                                                        type="select"
                                                        name="Latest"
                                                        onChange={e => this.handleDateInputChange(e, masterIndex)}
                                                        value={master.Latest}
                                                    >
                                                        {[...this.props.available_dates].reverse().map(d => (
                                                            <option key={'latest_current_date_' + d.date_key} value={d.date_key}>{d.date_string}</option>
                                                        ))}
                                                        <option value={''}>LATEST</option>
                                                    </Input>
                                                </Col>
                                                <Col md={1} className="text-right">
                                                </Col>
                                            </Row>
                                            {master.children.filter(item => item.ID != null).map((child, childIndex) => (
                                                <Row key={"child_" + child.ID} className="linkedChild py-2 align-items-center">
                                                    <Col md={5} className="text-left linkedChildName">
                                                        <Link to={{ pathname: '/demographics/' + child['SEC#'], state: { currentDate: child.Latest === '' ? [...this.props.available_dates].pop().date_key : String(child.Latest).substr(-6) } }}>{child.Name}</Link>
                                                    </Col>
                                                    <Col md={3} className="py-2">
                                                        <Input
                                                            type="select"
                                                            name="Earliest"
                                                            onChange={e => this.handleDateInputChange(e, masterIndex, childIndex)}
                                                            value={child.Earliest}
                                                        >
                                                            {[...this.props.available_dates].reverse().map(d => (
                                                                <option key={'master_earliest_current_date_' + d.date_key} value={d.date_key}>{d.date_string}</option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                    <Col md={3} className="py-2">
                                                        <Input
                                                            type="select"
                                                            name="Latest"
                                                            onChange={e => this.handleDateInputChange(e, masterIndex, childIndex)}
                                                            value={child.Latest}
                                                        >
                                                            {[...this.props.available_dates].reverse().map(d => (
                                                                <option key={'master_latest_current_date_' + d.date_key} value={d.date_key}>{d.date_string}</option>
                                                            ))}
                                                            <option value={''}>LATEST</option>
                                                        </Input>
                                                    </Col>
                                                    <Col md={1} className="text-right">
                                                        <ConfirmButton title="Remove Company" className="mr-2" color="danger" onClick={() => this.onRemove(child.ID)} ><FontAwesomeIcon icon={faTimes} /></ConfirmButton>
                                                    </Col>
                                                </Row>
                                            ))}
                                            <Row>
                                                <Col md={5} className="py-3">
                                                    <Autocomplete {...this.props}
                                                        available_dates={this.props.available_dates}
                                                        newPage={false}
                                                        timeout={timeout}
                                                        showHistory={showHistory}
                                                        placeholder="Search to Add Child Company"
                                                        onSelect={(val) => this.onSelectAutocomplete(val, master.ID)}
                                                        clearOnSelect={true}
                                                        showContacts={false}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6} className="py-2">
                                                </Col>
                                                <Col md={3} className="py-2">
                                                    <Link className="btn btn-primary btn-block" to={{ pathname: '/master-child-demographics/' + master['SEC#'] }}>Compare</Link>
                                                </Col>
                                                <Col md={3} className="py-2">
                                                    <ConfirmButton color="danger" onClick={() => this.onRemove(master.ID)} block>Remove Group</ConfirmButton>
                                                </Col>
                                            </Row>
                                        </CollapseCard>
                                    </Col>
                                </Row>
                            ))}
                        </CardBody>
                    </Collapse>
                </Card>
            </Container>
        );
    }
}

export default LinkedCompanies;